import { Injectable, inject } from '@angular/core';

import { ThemeService } from '@app/core/services/theme.service';
import { Themes } from '@app/core/enums/themes.enum';

@Injectable()
export class AppLoadService {
  private themeService = inject(ThemeService);

  initAppParams(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.themeService.canChangeTheme()) {
        this.initTheme();
      }
      resolve(true);
    });
  }

  private extractThemeFromUrl(): Themes | null {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('theme')) {
      return null;
    }

    const themeInUrl = urlParams.get('theme');
    if (themeInUrl === Themes.Light) {
      return Themes.Light;
    } else if (themeInUrl === Themes.Dark) {
      return Themes.Dark;
    }

    return null;
  }

  private removeThemeFromUrl(): void {
    const currentURL = new URL(window.location.href);
    if (!currentURL.searchParams.has('theme')) {
      return;
    }
    currentURL.searchParams.delete('theme');
    window.history.replaceState(null, '', currentURL);
  }

  private initTheme(): void {
    let theme = this.extractThemeFromUrl();
    if (theme) {
      this.removeThemeFromUrl();
    } else {
      theme =
        this.themeService.getStoredTheme() ??
        this.themeService.getBrowserTheme();
    }
    this.themeService.initTheme(theme);
  }
}
